import styled from 'styled-components';

export const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const GridSection = styled.div`
  display: grid;
  gap: 4px;
  padding: 10px;
  width: 100%;
  grid-template-columns: ${({ columns }) => `repeat(${columns}, 1fr)`};
`;

export const customRangeSection = styled.div`
display:'flex';
justifyContent:'center';
padding:'5px';
marginTop:'5px';
`;

export const GridItem = styled.div`
  background-color: #f0f0f0;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border-radius: 1px;
  height: 20px;

  &.selected {
    background-color: #8c52ff;
  }

  &:hover {
    background-color: #8c52ff;
  }
`;

export const GridCount = styled.div`
  height: 20px;
  font-size: 14px;
  color: #fff;
`;
